import { makeStyles, Theme } from '@material-ui/core/styles';

// The contract-type label column width. The deactivated hint indents by exactly
// this much so it lines up under the select rather than under the label — the
// two values are the same number for a reason, so bind them to one constant
// instead of letting a future resize silently drift them apart (review on #2211).
const LABEL_WIDTH = 160;

export const useStyles = makeStyles<Theme>(theme => ({
  // One contract-type bucket: the picker row, plus the hint that appears when
  // the assigned template has been deactivated (AXHE-3836). The bottom margin
  // lives here rather than on `row` so the hint stays inside the group.
  bucketGroup: {
    marginBottom: theme.spacing(2),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  inactiveHint: {
    marginTop: theme.spacing(1),
    marginLeft: LABEL_WIDTH,
    color: theme.palette.common.orange400,
  },
  contractTypeLabel: {
    width: LABEL_WIDTH,
    flexShrink: 0,
    color: theme.palette.common.gray800,
  },
  select: {
    flex: 1,
  },
  errorsAlert: {
    marginBottom: theme.spacing(3),
    '& > div': {
      margin: 'initial',
    },
  },
  noTemplatesLink: {
    color: theme.palette.common.blue400,
  },
}));
